import { makeStyles } from 'tss-react/mui';

const useStylesPaddedFlexContainer: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  paddedFlexContainer: {
    padding: 10,
  },
  paddedFlexContainerSmall: {
    padding: 5,
  },
  paddedFlexContainerLarge: {
    padding: 20,
  },
  paddedFlexContainerExtended: {
    padding: '10px 0',
  },
}));

export default useStylesPaddedFlexContainer;
